import { Component, Input } from '@angular/core';

@Component({
  selector: 'empty-state',
  templateUrl: 'empty-state.html'
})
export class EmptyStateComponent {
  @Input() msg: string = '';
  @Input() img: string = '';

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/components/empty-state/empty-state.ts